/**
 * Deal list "Received Date" column.
 * Prefer worksheet contract_date (business/contracted date) over deal.received_date,
 * which on migration often equals DealIQ create time (received_data = new Date()).
 */
export function resolveDealListReceivedDate(item) {
  const worksheets = item?.worksheets || [];
  for (const w of worksheets) {
    const contractDate = w?.contract_date ?? w?.attributes?.contract_date;
    if (contractDate) return contractDate;
  }
  return item?.received_date || item?.received_data || null;
}
